module.exports = __webpack_public_path__ + "static/img/service-2.bdce08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service-2.png
// module id = N0rr
// module chunks = 1